
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45.332","height":"45.332","viewBox":"0 0 11.994 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.99 5.997a5.997 5.997 0 11-11.994 0 5.997 5.997 0 0111.994 0","fill":"#e6e6e6"}}),_c('g',{attrs:{"fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":".388"}},[_c('path',{attrs:{"d":"M9.24 1.618a.918.918 0 00-.918-.919L3.46.692a.92.92 0 00-.918.917l-.001.44 6.7.006zM2.53 10.478c0 .507.41.919.916.919l4.863.006a.916.916 0 00.918-.915l.001-.973-6.697-.006zM5.14 10.421h1.497"}}),_c('path',{attrs:{"d":"M7.7 7.295H4.267a.873.873 0 01-.073-1.743v-.008a1.02 1.02 0 011.422-.938A1.216 1.216 0 017.633 5.78.76.76 0 117.7 7.295zM2.539 2.05l-.01 7.46 6.697.005.012-7.46z"}}),_c('path',{attrs:{"d":"M7.7 5.775a.844.844 0 00-.067.003 1.212 1.212 0 00-2.017-1.172 1.02 1.02 0 00-1.422.937v.008a.873.873 0 00.073 1.743H7.7a.76.76 0 000-1.519zM8.53 2.055L7.231 3.354M7.28 2.055l-.625.625M3.26 9.514l1.266-1.267"}})])])
          )
        }
      }
    